import { useState } from 'react';
import CustomModal from '../../Util/Modal/CustomModal';
import Fetch from '../../functions/Fetch';
import Toast from '../../Util/Toast/Toast';
import { generatePositionsPdf } from '../../../positions/Export/generatePositionsPdf';

export function usePositionsExportPortal({ endpoint, baseFilter }) {
    const [showModal, setShowModal] = useState(false);
    const [sortOrder, setSortOrder] = useState('alphabetical');
    const [statusFilter, setStatusFilter] = useState('active');
    const [isGenerating, setIsGenerating] = useState(false);

    const openModal = () => setShowModal(true);
    const closeModal = () => setShowModal(false);

    const handleGenerate = async () => {
        setIsGenerating(true);
        try {
            const order = sortOrder === 'cbo' ? [['co.code', 'ASC']] : [['rn.name', 'ASC']];
            const filter = { ...baseFilter };
            if (statusFilter === 'active') {
                filter.status = '1';
            }

            const rows = await Fetch.post(endpoint, { filter, order });

            if (!rows || rows.length === 0) {
                Toast.error('Nenhum cargo encontrado para os filtros selecionados.');
                setIsGenerating(false);
                return;
            }

            generatePositionsPdf(rows);
            closeModal();
        } catch (e) {
            Toast.error(e);
        }
        setIsGenerating(false);
    };

    const modalContent = (
        <div>
            <div style={{ marginBottom: '20px' }}>
                <label><strong>Ordenação</strong></label>
                <div>
                    <label style={{ marginRight: '15px', fontWeight: 'normal' }}>
                        <input
                            type="radio"
                            name="pdc-positions-export-portal-sort"
                            checked={sortOrder === 'alphabetical'}
                            onChange={() => setSortOrder('alphabetical')}
                        /> Ordem Alfabética (Nome do Cargo de A a Z)
                    </label>
                </div>
                <div>
                    <label style={{ fontWeight: 'normal' }}>
                        <input
                            type="radio"
                            name="pdc-positions-export-portal-sort"
                            checked={sortOrder === 'cbo'}
                            onChange={() => setSortOrder('cbo')}
                        /> Ordem por Código CBO (Numérico crescente)
                    </label>
                </div>
            </div>
            <div style={{ marginBottom: '20px' }}>
                <label><strong>Status</strong></label>
                <div>
                    <label style={{ marginRight: '15px', fontWeight: 'normal' }}>
                        <input
                            type="radio"
                            name="pdc-positions-export-portal-status"
                            checked={statusFilter === 'active'}
                            onChange={() => setStatusFilter('active')}
                        /> Apenas Ativos
                    </label>
                </div>
                <div>
                    <label style={{ fontWeight: 'normal' }}>
                        <input
                            type="radio"
                            name="pdc-positions-export-portal-status"
                            checked={statusFilter === 'all'}
                            onChange={() => setStatusFilter('all')}
                        /> Todos (Ativos e Inativos)
                    </label>
                </div>
            </div>
            <div style={{ textAlign: 'right' }}>
                <button type="button" className="btn btn-secondary" style={{ marginRight: '10px' }} onClick={closeModal}>
                    Cancelar
                </button>
                <button type="button" className="btn btn-primary" disabled={isGenerating} onClick={handleGenerate}>
                    {isGenerating ? 'Gerando...' : 'Gerar PDF'}
                </button>
            </div>
        </div>
    );

    const modal = (
        <CustomModal
            show={showModal}
            title="Gerar Fichas de Cargos (PDF)"
            content={modalContent}
            handleClose={closeModal}
            showButtons={false}
        />
    );

    return { modal, openModal };
}
